import { render, staticRenderFns } from "./CalculateSalaryProcessGView.vue?vue&type=template&id=83e70af6&"
import script from "./CalculateSalaryProcessGView.vue?vue&type=script&lang=js&"
export * from "./CalculateSalaryProcessGView.vue?vue&type=script&lang=js&"
import style0 from "./CalculateSalaryProcessGView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports